import { queryOptions } from '@tanstack/react-query';
import type { AccountsEmailSetupStatusResponse } from '@customerio/hydra-ui-api';
import { hydraUiApi } from '@/services/api';

/**
 * Account-level email-setup status (`GET /accounts/:id/email_setup_status`).
 * The connections overview's Email channel gate mirrors Ember's
 * `adventures.isEmailSetupComplete`, which combines these two flags with the
 * account's verification state (resolved separately from the auth store).
 */

const STALE_TIME = 60_000;

/** @public Returned as the API sends it (`has_from_address` / `has_verified_sending_domain`). */
export async function getEmailSetupStatus(accountId: number): Promise<AccountsEmailSetupStatusResponse> {
  return await hydraUiApi.accounts.getEmailSetupStatus({
    params: { path: { account_id: String(accountId) } },
  });
}

/** @public */
export const getEmailSetupStatusQueryOptions = (accountId: number) =>
  queryOptions({
    queryKey: ['account', accountId, 'email-setup-status'] as const,
    queryFn: () => getEmailSetupStatus(accountId),
    staleTime: STALE_TIME,
  });
